<template>
  <div class="slide acce zoom" v-parallax-fit="acce"></div>
</template>

<script>
export default {
  name: 'slide25',
  data() {
    return {
      acce: [
        {
          start: 33400,
          end: 33600,
          fromStyle: { transform: 'translateX(416px) translateY(-330px) rotate(0deg)' },
          toStyle: { transform: 'translateX(416px) translateY(30px) rotate(10deg)' }
        },
        {
          start: 33600,
          end: 33800,
          fromStyle: { transform: 'translateX(416px) translateY(30px) rotate(10deg) scale(1)' },
          toStyle: { transform: 'translateX(0px) translateY(400px) rotate(-10deg) scale(1.15)' }
        },
        {
          start: 33800,
          end: 34200,
          fromStyle: { transform: 'translateX(0px) translateY(400px) rotate(-10deg) scale(1.15)' },
          toStyle: { transform: 'translateX(-400px) translateY(600px) rotate(-15deg) scale(1.2)' }
        },
        {
          start: 34200,
          end: 34800,
          fromStyle: { transform: 'translateX(-400px) translateY(600px) rotate(-15deg) scale(1.2)' },
          toStyle: { transform: 'translateX(216px) translateY(60px) rotate(15deg) scale(1.2)' }
        },
        {
          start: 34800,
          end: 35200,
          fromStyle: { transform: 'translateX(216px) translateY(60px) rotate(15deg) scale(1.2)' },
          toStyle: { transform: 'translateX(216px) translateY(560px) rotate(-15deg) scale(1)' }
        },
        {
          start: 35200,
          end: 35800,
          fromStyle: { transform: 'translateX(216px) translateY(560px) rotate(-15deg) scale(1)' },
          toStyle: { transform: 'translateX(0px) translateY(550px) rotate(0deg) scale(1.15)' }
        },
        {
          start: 36500,
          end: 37000,
          fromStyle: { transform: 'translateX(0px) translateY(550px) rotate(0deg) scale(1.15)' },
          toStyle: { transform: 'translateX(0px) translateY(2200px) rotate(12deg) scale(1.15)' }
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.acce {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/25_acce.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 330px;
    height: 330px;
    transition: 0.3s;
    transform-origin: center;
    z-index: 12;
    left: calc(50% - 51px);
    top: 0;
    @media(max-width: 600px) {
      top: -100px;
      width: 140px;
      height: 140px;
    }
    @media(max-width: 400px) {
		left: 0%;
		top: -28%;
		width: 110px;
      	height: 110px;
    }
}
@keyframes acce_logo {
	0% { transform: translate(-100px, -30px) rotate(10deg); opacity: 1 }
	16% { transform: translate(-200px, 344px) rotate(0deg);}
	33% { transform: scale(1.28) rotate(5deg) translate(-266px, 343px);}
	49% { transform: scale(1.28) rotate(5deg) translate(-266px, 343px) rotate(180deg) translate(322px, -208px) rotate(180deg);}
	65% { transform: scale(1.28) rotate(5deg) translate(-266px, 343px) rotate(360deg) translate(314px, -314px) rotate(373deg)}
	80% { transform: scale(1.28) rotate(5deg) translate(-266px, 343px) rotate(420deg) translate(247px, -264px) rotate(292deg);}
	100% { transform: scale(1.28) rotate(5deg) translate(-266px, 343px) rotate(420deg) translate(82px,-7px) rotate(295deg)}
}
</style>
